module.exports = __webpack_public_path__ + "gt.svg?aa33e6773643efd03d382429039986d9";